import React, { forwardRef, useCallback } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import GitlabSecurityMappingForm from "./GitlabSecurityMappingForm";
import { SLOW_PROJECT_LOADING_ALERT } from "../tenableCloudSecurity/TenableCloudSecurityCredentialsForm";

const PLAN_OPTIONS = [{label: "Premium", value: "premium"}, {label: "Ultimate", value: "ultimate"}]

function GitlabSecurityCredentialsForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "token",
      label: "Token",
      required: true,
      type: FieldTypes.PASSWORD,
    },
    {
      name: "plan",
      label: "Plan",
      type: FieldTypes.RADIO,
      disabled: props.config,
      options: PLAN_OPTIONS,
      required: true,
    },
    {
      name: "mapArchived",
      label: "Map Archived Repos",
      type: FieldTypes.BOOLEAN,
      inline: true,
    },
    {
      name: "message",
      type: FieldTypes.LABEL,
      value: SLOW_PROJECT_LOADING_ALERT
  }
  ];

  const parseExtraFields = useCallback((config) => {
    return { ...config, mapArchived: !(config.mapArchived === "false") };
  }, []);

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={GitlabSecurityMappingForm}
      initialValue={{ apiEndpoint: 'https://gitlab.com/api', mapArchived: false }}
      parseExtraFields={parseExtraFields}
    />
  );
}

export default forwardRef(GitlabSecurityCredentialsForm);
